<template>
  <nd-dialog
    v-model="visible"
  >
    <div class="dialog-content" slot="custom">
      <div class="content-title">
        <img class="title-icon" src="./images/logo_font@2x.png" alt="">
      </div>
      <div class="content-info">您有一笔额度待领取</div>
      <div class="content-amount">
        最高
        <span class="fz1">￥</span>
        <span class="fz2">50,000</span>
      </div>
      <div class="content-tips">
        <div class="tips-icon">
          <img src="./images/icon_tianxie@2x.png" alt="">
        </div>
        <div class="tips-main">立即补充资料即可领取</div>
      </div>
      <img src="./images/img_qian@2x.png" alt="" class="content-img">
      <nd-button class="content-btn" @click="handleRoute">立即前往</nd-button>
      <div class="content-giveup" @click="visible = false">残忍拒绝</div>
    </div>
  </nd-dialog>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DialogBack',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState('user', {
      quotaInfo: state => state.quotaInfo,
      authStatus: (state) => state.userInfo.authStatus || [],
      hasDiversion: (state) => state.userInfo.hasDiversion
    }),
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    // 去提现结果页
    goWithdrawResult () {
      // 如果是导流用户就去特权卡中间页
      if (this.hasDiversion) {
        this.$router.push('/privilege/middle?isHome=T')
      } else {
        this.$router.push(`/withdraw/result?loanApplyNo=${this.quotaInfo.serialNo}`)
      }
    },
    // 跳转
    handleRoute () {
      this.$router.push('/middle/limit')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.dialog-content{
  width: 620px;
  padding-bottom: 40px;
  background: linear-gradient(180deg, #FFF9F3 0%, #FFECEC 100%);
  box-shadow: 0px 0px 20px 0px #FF9E91;
  border: 1px solid #FFFFFF;
  border-radius: 30px;
  position: relative;
  padding-top: 107px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .content-title{
    width: 294px;
    height: 74px;
    background: linear-gradient(270deg, #FFBDB7 0%, #FFEFE6 52%, #FFD096 100%);
    border-radius: 4px 4px 34px 34px;
    border: 1px solid #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -6px;
    .title-icon{
      width: 118px;
      height: 39px;
    }
  }
  .content-info{
    font-size: 44px;
    color: #290E08;
    font-weight: bold;
    line-height: 72px;
  }
  .content-amount{
    font-size: 77px;
    color: #FF4B32;
    font-weight: bold;
    line-height: 108px;
    margin-top: -10px;
    .fz1{
      font-size: 44px;
      margin: 0 -25px;
    }
    .fz2{
      font-family: DIN-medium, DIN;
    }
  }
  .content-tips{
    display: flex;
    border: 1PX solid #290E08;
    font-size: 32px;
    color: #290E08;
    width: 452px;
    .tips-icon{
      width: 82px;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #290E08;
      img{
        width: 32px;
        height: 32px;
      }
    }
    .tips-main{
      flex: 1 1 auto;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .content-img{
    width: 256px;
    height: 248px;
    margin-top: 22px;
  }
  .content-btn{
    width: 440px;
    margin-top: -70px;
  }
  .content-giveup{
    font-size: 32px;
    color: #BBA6A4;
    margin-top: 25px;
  }
}
</style>